import { Button, Loader, Stack, Typography } from '@karma/components';
import { CoinIconFilled, SadIconFilled, TrashIconFilled } from '@karma/components/icons';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { getAccountDeleteIsFetching, getAccountDeleteSuccess, getWallet } from 'store/user/selectors';
import Alooma from 'services/alooma';
import * as ALOOMA from 'consts/alooma';
import useAction from 'hooks/useAction';
import { deleteAccount } from 'store/user/actions';
import { Container } from './ModalBodyDeleteAccount.style';

const ModalBodyDeleteAccount = ({ closeModal }) => {
  const { t } = useTranslation();
  const wallet = useSelector(getWallet);
  const contextDataAttrs = Alooma.useContextDataAttrs();
  const deleteAccountFunc = useAction(deleteAccount);
  const isFetching = useSelector(getAccountDeleteIsFetching);
  const deleteSuccess = useSelector(getAccountDeleteSuccess);

  if (isFetching)
    return (
      <Container>
        <Loader />
      </Container>
    );

  if (!isFetching && deleteSuccess) {
    return (
      <Container direction="column" spacing={20}>
        <SadIconFilled width={60} height={60} />
        <Typography variant="h3">{t('app:accountDeletedSuccessfully')}</Typography>
      </Container>
    );
  }

  return (
    <Container direction="column" spacing={20} fullWidth>
      <TrashIconFilled width={60} height={60} />

      <Stack direction="column" fullWidth>
        <Typography variant="h3">{t('app:areYouSureDeleteAccount')}</Typography>

        {wallet?.balances?.amount_usd >= 5 && (
          <Stack direction="row" spacing={2} tMargin={8}>
            <Typography variant="labelLarge">
              {t('app:youHaveInYourWallet')} {wallet?.balances?.amount?.toLocaleString()}
            </Typography>
            <CoinIconFilled size="small" color="color2" secondaryColor="color1" />
          </Stack>
        )}

        <Typography variant="paragraphLarge" tMargin={16}>
          {t('app:deletingYourAccountWill')}
        </Typography>
      </Stack>

      <Button
        size="medium"
        fullWidth
        onClick={closeModal}
        {...contextDataAttrs}
        data-alooma-element={ALOOMA.ELEMENTS.CANCEL}
      >
        {t('app:cancel')}
      </Button>
      <Button
        type="outline"
        size="medium"
        fullWidth
        onClick={() => deleteAccountFunc()}
        {...contextDataAttrs}
        data-alooma-element={ALOOMA.ELEMENTS.DELETE_MY_ACCOUNT}
      >
        {t('app:deleteMyAccount')}
      </Button>
    </Container>
  );
};

export default ModalBodyDeleteAccount;
